export const formatNumberUtil = (value: number | undefined) => {
	if (value === undefined) {
		return;
	}

	return value.toLocaleString(undefined, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	});
}
